import 'babel-polyfill'

import Vue from 'vue'

if(document.getElementById("popup_NONTRANSPARENT_OR_INCORRECT_INFO_app")) {
    var app = new Vue({
        delimiters: ['[[', ']]'],
        el: '#popup_NONTRANSPARENT_OR_INCORRECT_INFO_app',
        data: {
            showRawData: false,
        },
        methods: {
            toggleRawData: function() {
                this.showRawData = !this.showRawData;
            }
        }
    })
}